import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { LoginContainer, LogoContainer, Title } from "@/components/atoms"
import Acess from "../molecules/Acess.vue"

export default /*#__PURE__*/_defineComponent({
  __name: 'Login',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(LoginContainer), null, {
    default: _withCtx(() => [
      _createVNode(_unref(LogoContainer), null, {
        default: _withCtx(() => [
          _createVNode(_unref(Title), null, {
            default: _withCtx(() => [
              _createTextVNode("Portal Comissão")
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(Acess)
    ]),
    _: 1
  }))
}
}

})